import React from 'react'
import { Form } from 'react-bootstrap'
import { Button } from '../../../components/Button/Button'

export const MAX_USER_QUESTION_LENGTH = 350

export type CrossClientQueryInputMode = 'input' | 'working' | 'review'

interface CrossClientQueryInputProps {
  userQuestion: string
  onQuestionChange: (question: string) => void
  onSubmit: () => Promise<void>
  disabled: boolean
  submitDisabled: boolean
  isLoading: boolean
  hasExecution: boolean
  mode?: CrossClientQueryInputMode
  reviewContent?: React.ReactNode
  footerLeft?: React.ReactNode
  footerRight?: React.ReactNode
}

export const CrossClientQueryInput = ({
  userQuestion,
  onQuestionChange,
  onSubmit,
  disabled,
  submitDisabled,
  isLoading,
  hasExecution,
  mode = 'input',
  reviewContent,
  footerLeft,
  footerRight,
}: CrossClientQueryInputProps) => {
  const handleKeyDown = async (e: React.KeyboardEvent<HTMLTextAreaElement>) => {
    if (isLoading || hasExecution) {
      return
    }
    if (e.key === 'Enter') {
      e.preventDefault()
      if (e.ctrlKey || e.metaKey) {
        onQuestionChange(`${userQuestion}\n`)
      } else if (!submitDisabled) {
        await onSubmit()
      }
    }
  }

  return (
    <div className='d-flex flex-column'>
      <div className='px-3 pt-3 pb-3'>
        {mode === 'input' ? (
          <Form.Control
            className='p-0 border-0 cross-client-input-textarea'
            as='textarea'
            value={userQuestion}
            maxLength={MAX_USER_QUESTION_LENGTH}
            onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) => {
              onQuestionChange(e.currentTarget.value)
            }}
            disabled={disabled}
            onKeyDown={handleKeyDown}
            placeholder='Example: Which clients are approaching retirement with over $500k in assets?'
          />
        ) : (
          <div className='d-flex flex-column gap-3 cross-client-working'>
            <p className='paragraph-medium cross-client-working__question'>{userQuestion}</p>
            {mode === 'working' ? (
              <div className='d-flex align-items-center gap-2 cross-client-working__status'>
                <div className='cross-client-working__bullet' />
                <span className='paragraph-medium shimmering-loader-text'>Breaking down your question into search criteria…</span>
              </div>
            ) : (
              reviewContent
            )}
          </div>
        )}
      </div>
      <div className='w-100 cross-client-chat-divider' />
      <div className='d-flex align-items-center justify-content-between px-3 py-2 gap-3'>
        <div className='d-flex gap-2 align-items-center'>{footerLeft}</div>
        <div className='d-flex gap-2 align-items-center'>
          {footerRight}
          {mode === 'input' ? (
            <Button
              className='d-inline-flex align-items-center justify-content-center cross-client-send-button'
              onClick={onSubmit}
              disabled={submitDisabled || isLoading || hasExecution}
              aria-label='Submit query'
            >
              <i className='bi bi-arrow-up' />
            </Button>
          ) : null}
        </div>
      </div>
    </div>
  )
}
